import * as React from 'react';
import { IGraphData, IGraphResponseData, getIsMoreThanOneDay } from '../GraphService';
import EvBatteryChart from './EvBatteryChart';

interface IProps {
  responseData: IGraphResponseData[];
  isCompressed: boolean;
  isSelectable: boolean;
  vehicleTankCapacity: number;
  selectedDate: Date[];
}

function Stopped(props: IProps) {
  const [graphData, setGraphData] = React.useState<IGraphData>({
    xLabels: [],
    yLabels: [],
    tooltips: {},
    minLabels: [],
    maxLabels: [],
  });

  const getData = () => {
    const xLabels: string[] = [];
    const yLabels: (null | number)[] = [];
    const minLabels: string[] = [];
    const maxLabels: string[] = [];
    const tooltips = {};
    if (props.responseData) {
      props.responseData.forEach((i) => {
        if (!xLabels.includes(i.timestamp)) {
          xLabels.push(i.timestamp);
          yLabels.push(i.value);
          minLabels.push(i.min);
          maxLabels.push(i.max);
          tooltips[i.timestamp] = {
            address: i.address || `${i.latitude}, ${i.longitude}`,
            code: i.code,
          };
        }
      });
    }
    setGraphData({
      xLabels,
      yLabels,
      minLabels,
      maxLabels,
      tooltips,
    });
  };

  React.useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.responseData]);

  return (
    <div>
      <EvBatteryChart
        graphData={graphData}
        noAnimation="animation"
        isCompressed={props.isCompressed}
        isSelectable={props.isSelectable}
        vehicleTankCapacity={props.vehicleTankCapacity}
        isMoreThanOneDay={getIsMoreThanOneDay(props.selectedDate)}
      />
    </div>
  );
}

export default React.memo(Stopped);
